import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';

import { PUT_NICKNAME_REQUEST, PUT_NICKNAME_SUCCESS, PUT_NICKNAME_FAILURE, COMMON_FAILURE } from '../../actions';
import { nicknameService } from '../../services';
import { historyType } from '../../../utils/commonType';

export type putNicknameAction = {
  type: typeof PUT_NICKNAME_REQUEST;
  memberId: string;
  nickname: string;
  history: historyType;
};

function* putNickname(action: putNicknameAction): Generator<unknown> {
  try {
    const res: any = yield call(nicknameService(action).putNickname);
    yield put({
      type: PUT_NICKNAME_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: PUT_NICKNAME_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchPutNickname() {
  yield takeLatest(PUT_NICKNAME_REQUEST, putNickname);
}

export default function* nicknameSaga(): Generator<unknown> {
  yield all([fork(watchPutNickname)]);
}
